// export const BASE_URL = 'http://localhost/';
export const BASE_URL = 'https://apiadmin.allgeconsultoria.com/index.php/';